import React from 'react'
import Skeleton from 'react-loading-skeleton';

const createSkeletonRow = () => ({
      cellData: [
        {
          value: (
            <>
              <Skeleton width="100%" baseColor="#ffffff00" highlightColor="#fff" height="1.5rem" />
            </>
          ),
          className: "text-start",
        },
        {
          value: (
            <>
             <Skeleton width="100%" baseColor="#ffffff00" highlightColor="#fff" height="1.5rem" />
            </>
          ),
          className: "text-start",
        },
        {
          value: (
            <>
              <Skeleton width="100%" baseColor="#ffffff00" highlightColor="#fff" height="1.5rem" />
            </>
          ),
        },
        {
          value: (
            <>
             <Skeleton width="100%" baseColor="#ffffff00" highlightColor="#fff" height="1.5rem" />
            </>
          ),
          className: "text-start",
        },
        {
          value: (
            <>
              <Skeleton width="100%" baseColor="#ffffff00" highlightColor="#fff" height="1.5rem" />
            </>
          ),
          className: "text-start",
        },
        {
          value: <Skeleton width="100%" baseColor="#ffffff00" highlightColor="#fff" height="1.5rem" />,
          className: "text-start",
        },
      ],
    });

export const generateInvoiceSkeletonRows  = (length = 5) => Array.from({ length }, createSkeletonRow);

